<div class="form-container">
  <div class="form-section">
    <div class="form-row">
      <div class="form-group">
        <label for="orderDate" class="form-label">
          <i class="icon-calendar"></i>
          Date of Supply
        </label>
        <input 
          type="date" 
          id="orderDate" 
          name="orderDate" 
          class="form-input"
          [(ngModel)]="PurchaseOrder.dateOfOrder" 
        />
      </div>
    </div>
  </div>

  <!-- Products Section -->
  <div class="form-section">
    <div class="section-header">
      <h3 class="section-title">
        <i class="icon-box"></i>
        Products
      </h3>
    </div>

    <div class="table-wrapper">
      <table class="products-table">
        <thead>
          <tr>
            <th>Item Name</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Total Price</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of orderItems; let i = index" class="table-row">
            <td class="item-cell">
              <select 
                class="form-select" 
                [(ngModel)]="row.itemName"
                [ngModelOptions]="{standalone: true}"
              >
                <option value="">Select Item</option>
                <option *ngFor="let opt of itemOptions" [value]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </td>
            <td class="quantity-cell">
              <input 
                type="number" 
                class="form-input" 
                [(ngModel)]="row.quantity"
                (input)="calculateRowTotal(i)" 
                [ngModelOptions]="{standalone: true}"
                placeholder="0"
              />
            </td>
            <td class="price-cell">
              <div class="price-input-wrapper">
                <span class="currency-symbol">₹</span>
                <input 
                  type="number" 
                  class="form-input price-input" 
                  [(ngModel)]="row.unitPrice"
                  (input)="calculateRowTotal(i)" 
                  [ngModelOptions]="{standalone: true}"
                  placeholder="0.00"
                />
              </div>
            </td>
            <td class="total-cell">
              <div class="price-input-wrapper">
                <span class="currency-symbol">₹</span>
                <input 
                  type="number" 
                  class="form-input price-input" 
                  [(ngModel)]="row.totalPrice" 
                  readonly
                  [ngModelOptions]="{standalone: true}"
                  placeholder="0.00"
                />
              </div>
            </td>
            <td class="action-cell">
              <button 
                type="button" 
                class="btn-remove" 
                (click)="removeRow(i)"
                title="Remove item"
              >
                <i class="icon-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-footer">
      <button type="button" class="btn-add-row" (click)="addRow()">
        <i class="icon-plus"></i>
        Add Item
      </button>
      <div class="final-price">
        <span class="price-label">Total Amount:</span>
        <span class="price-value">₹{{ calculateFinalPrice() | number:'1.2-2' }}</span>
      </div>
    </div>
  </div>
</div>